<div class="desktop">
  <ng-container *ngTemplateOutlet="desktop"></ng-container>
</div>
<div class="mobile">
  <ng-container *ngTemplateOutlet="mobile"></ng-container>
</div>

<ng-template #desktop>
  <div class="bonus-card card">
    <div class="bonus-card__section">
      <div class="bonus-card__section--info">
        <div class="bonus-card__section--info__title">
          {{ 't.free-spins' | translate }}
        </div>
        <div class="bonus-card__section--info__prize text-gradient">
          15 FREE SPINS
        </div>
        <div class="bonus-card__section--info__second-desc">
          {{ 't.dep-exit-prize-description-fs' | translate }}
        </div>
      </div>
    </div>
    <div class="bonus-card__section">
      <div class="bonus-card__section--action">
        <div class="bonus-card__section--action__button">
          <button routerLink="/deposit" class="btn small">
            {{ 'btn.deposit' | translate }}
          </button>
        </div>
        <div class="bonus-card__section--action__status">
          {{ 't.ndfs-status' | translate }}
        </div>
      </div>
    </div>
    <div class="bonus-card__section">
      <div class="bonus-card__section--image">
        <img src="/assets/img/ndfs.png" alt="">
      </div>
    </div>
  </div>
</ng-template>
<ng-template #mobile>
  <div class="bonus-card card">
    <div class="bonus-card__section">
      <div class="bonus-card__section--top">
        <div class="bonus-card__section--info">
          <div class="bonus-card__section--info__title">
            {{ 't.free-spins' | translate }}
          </div>
          <div class="bonus-card__section--info__prize text-gradient">
            15 FREE SPINS
          </div>
        </div>
        <div class="bonus-card__section--image">
          <img src="/assets/img/ndfs.png" alt="">
          <div class="bonus-card__section--status">
            {{ 't.ndfs-status' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="bonus-card__section">
      <div class="bonus-card__section--action">
        <div class="bonus-card__section--info__second-desc">
          {{ 't.dep-exit-prize-description-fs' | translate }}
        </div>
        <button routerLink="/deposit" class="btn small">
          {{ 'btn.deposit' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
